import moment from 'moment';

export function currency(value: any, d = ',', t = '.', precision = 2) {
	let v = value ? value : 0;
	let s = v < 0 ? "-" : "";
    let i = parseInt(Math.abs(v.toFixed(precision)) + "", 10) + "";
	let j = i.length > 3 ? i.length % 3 : 0;
    return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (precision ? d + Math.abs(v - parseInt(s + i)).toFixed(precision).slice(precision) : "");
}

export function percent(value: any) {
    let precision = 2;
	let symbol = "%";
	let decimal = ",";
    let v = value ? value.toFixed(precision) : 0.00;
    return (v+"").replace('.', decimal)+symbol;
}

export function human(value: number) {
	if (value >= 1000000) {
		return Math.round(value / 1000000) + 'M';
	} else if (value >= 1000) {
		return Math.round(value / 1000) + 'k';
	} else {
		return value;
	}
}

export function isoDate(dt: moment.Moment | string | null, nullValue = ''): string {
	if (!dt) { return nullValue }

	if (!moment.isMoment(dt)) {
		dt = moment(dt);
	}
	return dt.format("YYYY-MM-DD");
}

export function localizedDate(dt: moment.Moment | string | null, nullValue = ''): string {
	if (!dt) { return nullValue }

	if (!moment.isMoment(dt)) {
		dt = moment(dt);
	}
	return dt.format("L");
}

export function year(dt: moment.Moment | string | null, nullValue = ''): string {
	if (!dt) { return nullValue }

	if (!moment.isMoment(dt)) {
		dt = moment(dt);
	}
	return dt.format("YYYY");
}

export function month(dt: moment.Moment | string | null, nullValue = ''): string {
	if (!dt) { return nullValue }

	if (!moment.isMoment(dt)) {
		dt = moment(dt);
	}
	return dt.format("MM");
}

export function monthNameShort(dt: moment.Moment | string | null, nullValue = ''): string {
	if (!dt) { return nullValue }

	if (!moment.isMoment(dt)) {
		dt = moment(dt);
	}
	return dt.format("MMM");
}

export function monthNameFull(dt: moment.Moment | string | null, nullValue = ''): string {
	if (!dt) { return nullValue }

	if (!moment.isMoment(dt)) {
		dt = moment(dt);
	}
	return dt.format("MMMM");
}

export function day(dt: moment.Moment | string | null, nullValue = ''): string {
	if (!dt) { return nullValue }

	if (!moment.isMoment(dt)) {
		dt = moment(dt);
	}
	return dt.format("DD");
}

export function dayNameShort(dt: moment.Moment | string | null, nullValue = ''): string {
	if (!dt) { return nullValue }

	if (!moment.isMoment(dt)) {
		dt = moment(dt);
	}
	return dt.format("ddd");
}

export function dayNameFull(dt: moment.Moment | string | null, nullValue = ''): string {
	if (!dt) { return nullValue }

	if (!moment.isMoment(dt)) {
		dt = moment(dt);
	}
	return dt.format("dddd");
}

export function timeShort(dt: moment.Moment | string | null, nullValue = ''): string {
	if (!dt) { return nullValue }

	if (!moment.isMoment(dt)) {
		dt = moment(dt);
	}
	return dt.format("hh:mm");
}

export function timeFull(dt: moment.Moment | string | null, nullValue = ''): string {
	if (!dt) { return nullValue }

	if (!moment.isMoment(dt)) {
		dt = moment(dt);
	}
	return dt.format("hh:mm:ss");
}

export function timeFromNow(dt: moment.Moment | string | null, nullValue = ''): string {
	if (!dt) { return nullValue }

	if (!moment.isMoment(dt)) {
		dt = moment(dt);
	}
	return dt.fromNow();
}

export function ifEmpty(value: any, emptyResult: string): string {
	return isNullOrWhitespace(value) && emptyResult || value;
}

export function isNullOrWhitespace(text: any): boolean {
	if (text) {
		return text.toString().trim() == '';
	}
	return true;
}

export default {
	// Filters
	currency,
	percent,
	human,
	isoDate,
	localizedDate,
	year,
	month,
	monthNameShort,
	monthNameFull,
	day,
	dayNameShort,
	dayNameFull,
	timeShort,
	timeFull,
	timeFromNow,
	ifEmpty,

	// Utilities
	isNullOrWhitespace
}



// WEBPACK FOOTER //
// ./src/dndg/helpers/filters.ts